import React, { useState, useEffect } from 'react';
import {
  Typography,
  Paper, Tabs, Tab, TextField, Button, Box, Container, Checkbox, FormControlLabel, Grid,
  FormControl, InputLabel, Select, MenuItem, Snackbar, Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; 
import Footer from '../Materials/Footer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BurgerBar from '../Materials/BurgerBar';


export default function CreateEntityPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [image, setImage] = useState(null);

  const [entityTypes, setEntityTypes] = useState([]);
  const [selectedEntityTypeId, setSelectedEntityTypeId] = useState('');
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [headOffice, setHeadOffice] = useState('');
  const [emailContact, setEmailContact] = useState('');
  const [mainLocation, setMainLocation] = useState('');
  const [otherLocation, setOtherLocation] = useState('');
  const [latitudeCords, setLatitudeCords] = useState('');
  const [longitudeCords, setLongitudeCords] = useState('');
  const [description, setDescription] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isAssociate, setIsAssociate] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState(''); // Estado para armazenar o ID do utilizador logado

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const { user } = useAuth(); // Obtenha o utilizador logado do contexto

  useEffect(() => {
    if (user && user.userId) {
      setLoggedInUserId(user.userId); // Defina o ID do utilizador logado
    }
  }, [user]);

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleCreateEntity = async () => {
    const newEntity = {
      entity_type_id: selectedEntityTypeId,
      name: name,
      website: website,
      head_office: headOffice,
      email_contact: emailContact,
      main_location: mainLocation,
      other_location: otherLocation,
      latitude_cords: latitudeCords === '' ? null : parseFloat(latitudeCords),
      longitude_cords: longitudeCords === '' ? null : parseFloat(longitudeCords),
      description: description,
      is_verified: isVerified,
      is_associate: isAssociate,
      is_visible: isVisible,
      created_by: loggedInUserId // Adiciona o ID do utilizador logado
    };
   
    const formData = new FormData();
    // Adiciona os dados da entidade
    for (const key in newEntity) {
      formData.append(key, newEntity[key]);
    }
   
    // Adiciona a imagem se existir
    if (image) {
      formData.append('image', image); // A chave 'image' deve ser o campo que o backend espera
    }
   
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entities', {
        method: 'POST',
        body: formData // Envia os dados como FormData
      });
   
      if (!response.ok) {
        throw new Error('Erro ao criar a entidade');
      }
   
      // Limpa o formulário após sucesso
      setSelectedEntityTypeId('');
      setName('');
      setWebsite('');
      setHeadOffice('');
      setEmailContact('');
      setMainLocation('');
      setOtherLocation('');
      setLatitudeCords('');
      setLongitudeCords('');
      setDescription('');
      setIsVerified(false);
      setIsAssociate(false);
      setIsVisible(false);
      setImage(null); // Limpa a imagem
   
      showNotification('Entidade criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao criar entidade:', error);
      showNotification('Erro ao criar entidade', 'error');
    }
  };

  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/entity-types');
        if (!response.ok) {
          throw new Error('Erro ao buscar tipos de entidade');
        }
        const data = await response.json();
        setEntityTypes(data);
      } catch (error) {
        console.error('Erro ao buscar tipos de entidade:', error);
        showNotification('Erro ao carregar tipos de entidade', 'error');
      }
    };

    fetchEntityTypes();
  }, []);

  return (
    <>
      {/* Navbar */}
                  <BurgerBar />
      

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Tabs value={selectedTab} onChange={handleTabChange} centered>
            <Tab label="Entity" />
          </Tabs>
          <Typography variant="h5" sx={{ mt: 3, mb: 2 }}>
            Create New Entity
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
  <Box
    sx={{
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 2,
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      backgroundColor: '#fafafa'
    }}
  >
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        Entity Logo
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {image ? image.name : 'No logo selected'}
      </Typography>
    </Box>

    <Button
      component="label"
      variant="outlined"
      startIcon={<CloudUploadIcon />}
      sx={{
        textTransform: 'none',
        whiteSpace: 'nowrap'
      }}
    >
      Choose Logo

      <input
        hidden
        type="file"
        onChange={(e) => setImage(e.target.files[0])}
        accept="image/*"
      />
    </Button>
  </Box>
</Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="entity-type-label">Entity Type</InputLabel>
                <Select
                  labelId="entity-type-label"
                  value={selectedEntityTypeId}
                  onChange={(e) => setSelectedEntityTypeId(e.target.value)}
                  label="Entity Type"
                >
                  {entityTypes.map((entityType) => (
                    <MenuItem key={entityType.id} value={entityType.id}>
                      {entityType.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Name" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Website" fullWidth value={website} onChange={(e) => setWebsite(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Head Office" fullWidth value={headOffice} onChange={(e) => setHeadOffice(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Email Contact" fullWidth value={emailContact} onChange={(e) => setEmailContact(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Main Location" fullWidth value={mainLocation} onChange={(e) => setMainLocation(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Other Location" fullWidth value={otherLocation} onChange={(e) => setOtherLocation(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Latitude Coordinates" fullWidth value={latitudeCords} onChange={(e) => setLatitudeCords(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Longitude Coordinates" fullWidth value={longitudeCords} onChange={(e) => setLongitudeCords(e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Description" fullWidth multiline rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Created By"
                fullWidth
                value={loggedInUserId}
                disabled
                sx={{ display: 'none' }}
              />
            </Grid>
          </Grid>

          <FormControlLabel control={<Checkbox checked={isVerified} onChange={(e) => setIsVerified(e.target.checked)} />} label="Is Verified" />
          <FormControlLabel control={<Checkbox checked={isAssociate} onChange={(e) => setIsAssociate(e.target.checked)} />} label="Is Associate" />
          <FormControlLabel control={<Checkbox checked={isVisible} onChange={(e) => setIsVisible(e.target.checked)} />} label="Is Visible" />

          <Box sx={{ mt: 3 }}>
            <Button variant="contained" color="primary" onClick={handleCreateEntity}>
              Create Entity
            </Button>
          </Box>
        </Paper>
      </Container>

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>


           <Box>
             <Footer>
     
             </Footer>
           </Box>
    </>
  );
}